
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'load-more-list'
})
export default class extends Vue {
    @Prop({ default: true }) private hasMore!: boolean

    get textContent() {
        return this.hasMore ? '点击加载更多' : '加载完毕'
    }

    onLoadMore() {
        if (!this.hasMore) return
        this.$emit('fetch')
    }
}
